import fetchModels from "../../mixin/store/api/fetchModels";
import changeOrPushModel from "../../mixin/store/api/changeOrPushModel";
import deleteModel from "@/mixin/store/api/deleteModel";

export default {
    actions: {
        fetchEmployeePositions(context, data) {
            return fetchModels(context, 'employee_positions', data.page, 'updateEmployeePositions');
        },
        pushEmployeePosition(context, data) {
            return changeOrPushModel(context, 'employee_positions', data)
        },
        deleteEmployeePosition(context, id) {
            return deleteModel(context, 'employee_positions', id);
        },
    },
    mutations: {
        updateEmployeePositions(state, data) {
            state.employeePositions = data
        }
    },
    state: {
        employeePositions: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getEmployeePosition: (state, getters) => (id) => {
            return getters.getEmployeePositions.find( model => model.id === id )
        },
        getEmployeePositions(state) {
            return state.employeePositions.models
        },
        getEmployeePositionsTotalCount(state) {
            return state.employeePositions.totalItems
        }
    },
}
